/* eslint-disable @typescript-eslint/no-explicit-any -- complex types not adding much value */
import { createFaasProcedureConfig } from '@americanexpress/iguazu-procedures/utils/createFaasProcedureConfig';

const timeout = 60e3;

const createFetchOptsFromCallArgs = (args: RequestInit): RequestInit => {
  const { headers } = args;
  return { headers, body: JSON.stringify(args) };
};

const withLongerTimeoutAndResponseHandlingForSSR = ({ call, ...otherMethods }: any) => {
  const customCall = ({ fetchClient, ...rest }: any) => {
    const customFetch = (url: string, fetchOpts: RequestInit) =>
      fetchClient(url, {
        ...fetchOpts,
        timeout,
      }).then((response: Response) => {
        if (response.ok) {
          return response.text().then((res) => Promise.resolve(JSON.parse(res)));
        }
        return response.text().then((text) => {
          throw new Error(text);
        });
      });
    return call({
      fetchClient: customFetch,
      ...rest,
      handleResponse: false,
    });
  };

  return {
    call: customCall,
    ...otherMethods,
  };
};
/* eslint-enable @typescript-eslint/no-explicit-any -- complex types not adding much value */

const createFaasProcedureConfigForServerSideRendering = (functionName: string) =>
  withLongerTimeoutAndResponseHandlingForSSR(
    createFaasProcedureConfig(functionName, createFetchOptsFromCallArgs)
  );

export default createFaasProcedureConfigForServerSideRendering;
